import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import QuoteViewerTable from '../components/QuoteViewerTable';

const QuoteViewerList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">Quote Viewer</span>
      </Portal>
      {pageSize && <QuoteViewerTable />}
    </Card>
  );
};

export default QuoteViewerList;
